<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <b-row>
      <b-col lg="7">
        <b-row align-v="stretch">
          <b-col class="mb-5" lg="5">
            <statistics-card-line
              icon="CheckIcon"
              :statistic="totalCompOrder"
              :statisticTitle="$t('completedOrders')"
              :chartData="completeOrderSeries"
              type="area"
              color="success"
            ></statistics-card-line>
          </b-col>
          <b-col class="mb-5">
            <statistics-card-line
              icon="ShoppingBagIcon"
              :statistic="totalPickOrder"
              :statisticTitle="$t('PickingOrders')"
              color="primary"
              type="area"
              :chartData="pickOrderSeries"
            ></statistics-card-line>
          </b-col>
          <b-col class="mb-5">
            <statistics-card-line
              icon="XIcon"
              :statistic="totalNotCompOrder"
              :statisticTitle="$t('PackingOrders')"
              color="danger"
              type="area"
              :chartData="notCompleteOrderSeries"
            ></statistics-card-line>
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="5">
        <vx-card> 
          <chartjs-component-line-chart
            :height="250"
            :data="bestSellers"
            :chartData="bestSellers"
            :options="bestSellersOptions"
          ></chartjs-component-line-chart>
        </vx-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import ChartjsComponentLineChart from "@/components/charts-components/ChartjsComponentLineChart.vue";
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";
import VxTimeline from "@/components/timeline/VxTimeline";

export default {
  data() {
    return {
      bestSellersOptions: {
        title: {
          display: true,
          text: this.$t("Bestsellers"),
        },
      },
      bestSellers: {},
      ROLE: this.$store.state.AppActiveUser.ROLE,
      checkpointReward: {},
      subscribersGained: {},
      ordersRecevied: {},
      salesBarSession: {},
      supportTracker: {},
      productsOrder: {},
      completeOrderSeries: [{ name: "Orders", data: [] }],
      notCompleteOrderSeries: [{ name: "Orders", data: [] }],
      pickOrderSeries: [{ name: "Orders", data: [] }],
      totalCompOrder: 0.0,
      totalNotCompOrder: 0.0,
      totalPickOrder: 0.0,
      salesRadar: {},
      dispatchedOrders: [],
    };
  },
  components: {
    ChartjsComponentLineChart,
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline,
  },
  methods: {
    runReport(isOrder) {
      const vs = this.$vs;
      let methodName = "",
        compId = "";
      if (this.ROLE == "Company") compId = this.activeUserInfo.companyid;
      else compId = null;
      if (isOrder == "CompleteOrder") {
        methodName = this.ROLE == "Company" ? "TotalCompletedOrder" : "AdminTotalOrder";
      } else if (isOrder == "NotCompleteOrder") {
        methodName =
          this.ROLE == "Company" ? "TotalOrderNotComp" : "AdminTotalOrderNotComp";
      } else if (isOrder == "PickOrderSeries") {
        methodName = this.ROLE == "Company" ? "PickOrders" : "AdminPickOrder";
      } else if (isOrder == "BestSeller") {
        methodName = this.ROLE == "Company" ? "BestSeller" : "AdminBestseller";
      }
      let obj = {
        companyId: compId,
        name: methodName,
      };
      try {
        this.$store
          .dispatch("report/runReports", obj)
          .then((response) => {
            if (response.success == true) {
              try {
                let orderItemList = JSON.parse(response.json);
                if (isOrder == "CompleteOrder") {
                  this.totalCompOrder = orderItemList[0].OrderTotalCount;
                  this.completeOrderSeries = [{ name: "Orders", data: [] }]; //[{"name":"Orders","data":[10,15,8,15,7,12,8]}]
                  orderItemList.forEach((val, ind) => {
                    this.completeOrderSeries[0].data.push(val.OrderCount); 
                  });
                } else if (isOrder == "NotCompleteOrder") {
                  this.totalNotCompOrder = 0.0;
                  this.notCompleteOrderSeries = [{ name: "Orders", data: [] }]; //[{"name":"Orders","data":[10,15,8,15,7,12,8]}]
                  orderItemList.forEach((val, ind) => {
                    this.notCompleteOrderSeries[0].data.push(val.OrderCount);
                    this.totalNotCompOrder += val.OrderCount;
                  });
                } else if (isOrder == "PickOrderSeries") {
                  this.totalPickOrder = 0.0;
                  this.pickOrderSeries = [{ name: "Orders", data: [] }]; //[{"name":"Orders","data":[10,15,8,15,7,12,8]}]
                  orderItemList.forEach((val, ind) => {
                    this.pickOrderSeries[0].data.push(val.OrderCount);
                    this.totalPickOrder += val.OrderCount;
                  });
                } else if (isOrder == "BestSeller") {
                  let productList = JSON.parse(response.json);
                  this.bestSellers = Object.assign({});
                  this.$set(this.bestSellers, "labels", []);
                  this.$set(this.bestSellers, "datasets", []);
                  let label = [],
                    barcodeQty = [], marketplaces = [];
                  productList.forEach((val, index) => {
                    label.push(val.MarketPlaceOrderItemBarcode);
                    barcodeQty.push(parseInt(val.Quantity));
                    
                  });
                  this.bestSellers["labels"] = label; 
                  this.bestSellers.datasets.push({
                    label: "Çok satanlar",
                    data: barcodeQty,
                    borderColor: "#7367F0",
                    borderWidth: 2,
                  }); 
                }
              } catch (error) {
                console.log(error);
              }
            } else {
              console.log(response);
            }
          })
          .catch((error) => {
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  created() {
    this.runReport("CompleteOrder");
    this.runReport("NotCompleteOrder");
    this.runReport("PickOrderSeries");
    this.runReport("BestSeller");
  },
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */
</style>
